module.exports = __webpack_public_path__ + "static/img/person-icon.0bd30c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/person-icon.png
// module id = xoYE
// module chunks = 16